// Pro roster profiles - real-name villain SKINS over the archetype engine (North Star §4.4/§5;
// BUILD_PLAN D2 output 2). A pro is DATA: a real player name + a real documented style note mapped
// onto an existing archetype's ActionModel (optionally a blend). No new behavior lives here - 50+
// pros reuse the ~15 archetypes. D2 authors data/pros/roster.v1.json against these schemas; source
// of truth for the entries is packages/engine/src/data/pros/ROSTER_SOURCE.md.
import { z } from 'zod';
import { ArchetypeIdSchema } from './archetype';
/** The roster source's three activity buckets (ROSTER_SOURCE.md, activity read of 2026-07-08). */
export const ACTIVITY_TIERS = ['activeTour', 'selectiveLegend', 'cashGameLegacy'];
export const ActivityTierSchema = z.enum(ACTIVITY_TIERS);
export const ProProfileSchema = z.object({
    /** stable kebab-case slug, e.g. 'phil-ivey'. */
    id: z.string(),
    /** the real player name, used directly (personal tool - no disclaimers, North Star §4.4). */
    name: z.string(),
    /** primary archetype - the ActionModel the scenario engine runs when this pro takes a seat. */
    archetypeId: ArchetypeIdSchema,
    /** optional up-to-three-tag blend; same shape as ScenarioSpec.villains[].blend, weights sum to 1.
     *  The primary archetypeId is the highest-weight entry. */
    blend: z
        .array(z.object({ archetypeId: ArchetypeIdSchema, weight: z.number().min(0).max(1) }))
        .min(2)
        .max(3)
        .optional(),
    /** the player's real, documented style in one sentence (from ROSTER_SOURCE.md). */
    styleNote: z.string(),
    activityTier: ActivityTierSchema,
});
/** roster.v1.json as a versioned unit (mirrors ExploitRuleTableSchema). */
export const ProRosterSchema = z.object({
    version: z.number().int(),
    pros: z.array(ProProfileSchema),
});
//# sourceMappingURL=pro-profile.js.map